module.exports = __webpack_public_path__ + "static/Ergebnisse-Screen-Screen-8c6de846fa03a3f7180f4e94bd851d03.png";